import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../auth/AuthProvider";

const Hero = () => {
  const { user } = useAuth();
  return (
    <div id="hero" className="relative bg-white pb-24 min-h-screen overflow-hidden">
    {/* Background with dots pattern */}
    <div className="absolute top-0 lg:top-0 right-0 w-full lg:w-4/6 h-full bg-[url('/img/Website/Group.png')] bg-contain bg-no-repeat bg-right opacity-50 md:opacity-100 z-0"></div>
    
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 md:pt-32 relative z-10">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
        {/* Left Column - Text Content */}
        <div className="text-center lg:text-left">
          <h1 className="text-2xl sm:text-3xl md:text-[2.75rem] font-bold leading-tight text-[#002B5B]">
            DELIVERING <br />
            <span className="inline-block bg-primary-light text-white px-2 md:px-4 my-1 sm:my-2 mr-1 sm:mr-2">
              TRUST 
            </span>
            , SPEED
           
            & EFFICACY
          </h1>

          <p className="mt-3 md:mt-6 text-sm sm:text-base md:text-lg text-left text-gray-600">
            Your trusted partner for seamless logistics and delivery
            services across the US
          </p>

          <p className="mt-2 md:mt-4 text-sm sm:text-base text-left text-gray-600">
            <span className="text-[#0093D9] font-semibold">Secure Handling:</span> Your
            parcels are safe with us from pick-up to drop-off.
          </p>

          <div className="mt-6 md:mt-8 flex  sm:flex-row justify-center lg:justify-start gap-4">
            {!user && (
              <>
                <Link
                  to="/auth/signup"
                  className="order-1 sm:order-none w-[50%] flex-1 flex justify-center items-center px-4 sm:px-6 md:px-8 py-2 sm:py-3 text-sm sm:text-base font-medium rounded-md text-white bg-primary-dark hover:bg-[#001B3B] transition-all duration-200 shadow-[4px_10px_20px_0px_#5C28D44D]"
                >
                  SIGN UP NOW
                </Link>
                <Link
                  to="/auth/login"
                  className="order-2 sm:order-none w-[50%] flex-1 flex justify-center items-center px-4 sm:px-6 md:px-8 py-2 sm:py-3 text-sm sm:text-base font-medium rounded-md text-white bg-primary-light hover:bg-[#0083C9] transition-all duration-200 shadow-[4px_10px_20px_0px_#5C28D44D]"
                >
                  SIGN IN
                </Link>
              </>
            )}
            {user && (
              <Link
                to="/user/home"
                className="w-full flex justify-center items-center px-4 sm:px-6 md:px-8 py-2 sm:py-3 text-sm sm:text-base font-medium rounded-md text-white bg-primary-light hover:bg-[#0083C9] transition-all duration-200 shadow-[4px_10px_20px_0px_#5C28D44D]"
              >
                Account
              </Link>
            )}
          </div>
        </div>

        {/* Right Column - Image */}
        <div className="relative lg:flex justify-end mt-6 lg:mt-0">
          <div className="absolute top-[68%] right-[78%] w-12 sm:w-16 md:w-24 h-12 sm:h-16 md:h-24 p-6 sm:p-8 md:p-10 rounded-full bg-gradient-to-b from-primary-dark to-primary-light blur-sm z-50"></div>
          <img
            src="/img/Website/man.png"
            alt="Delivery Man"
            className="w-full h-[300px] sm:h-[400px] md:h-[600px] object-contain relative z-10"
          />
        </div>
      </div>
    </div>

    {/* Bottom Banner */}
    <div className="absolute left-0 right-0 bg-primary-dark text-white py-6 sm:py-8 md:py-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-xs sm:text-sm md:text-base px-4 sm:px-0">
          People who use <span className="text-[#0093D9] font-semibold">Impact Logistics</span> for their shipping save on average <br/> 32%
          on their shipments compared to other shipping companies.
        </p>
      </div>
    </div>
  </div>
  );
};

export default Hero;
